/* ==========================================================================
   DOUXDS quiz — brand behaviours the config schema cannot express.
   Loaded on index.html before quiz.config.js. The engine stays stock.

   Two jobs:
   1. The two-line headline device on question + interstitial screens.
   2. The capture field rendered as a phone keypad.
   ========================================================================== */

(function () {
  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c];
    });
  }

  /* ---- 0. Option icons ---------------------------------------------------
     DESIGN NOTE. DESIGN_SYSTEM.md says the brand's affordances are typographic
     and explicitly forbids pulling in Lucide/Heroicons. It does allow one
     thing: "a small set of single-colour brass line illustrations… bespoke
     artwork". So these are drawn for DOUXDS rather than imported — one weight,
     one colour, 24px grid, currentColor so they inherit the row's state.

     They are deliberately abstract. An honest icon for "dark marks" is two
     tones of the same shape, not a cartoon face — the system's rule that a
     picture must show the thing it names applies to icons too.

     The engine's own `illustration` field would flip the whole question to a
     card grid, so rows get their icon injected here instead. */
  var ICONS = {
    /* concerns */
    acne:    '<circle cx="12" cy="12" r="9"/><circle cx="9" cy="10" r="1.4" fill="currentColor" stroke="none"/><circle cx="15" cy="13" r="1.1" fill="currentColor" stroke="none"/><circle cx="11" cy="16" r="1" fill="currentColor" stroke="none"/>',
    razor:   '<rect x="4" y="5" width="16" height="6" rx="1.5"/><path d="M8 11v3M12 11v3M16 11v3"/><path d="M6 19h12"/>',
    mark:    '<circle cx="10" cy="12" r="6"/><circle cx="15" cy="12" r="6" fill="currentColor" opacity=".28" stroke="none"/><circle cx="15" cy="12" r="6"/>',
    scar:    '<path d="M6 18C9 13 12 11 18 6"/><path d="M9 12l2.5 2.5M12 9l2.5 2.5"/>',
    pores:   '<circle cx="8" cy="8" r="1.6"/><circle cx="14" cy="7" r="1.1"/><circle cx="17" cy="12" r="1.7"/><circle cx="11" cy="13" r="1.3"/><circle cx="7" cy="16" r="1.2"/><circle cx="14" cy="17" r="1.5"/>',
    /* duration */
    clock:   '<circle cx="12" cy="12" r="8.5"/><path d="M12 7.5V12l3 2"/>',
    cal:     '<rect x="4" y="6" width="16" height="14" rx="2"/><path d="M4 10h16M9 3.5v4M15 3.5v4"/>',
    loop:    '<path d="M7.5 9.5a3.2 3.2 0 100 5c2.6 0 4.4-5 7-5a3.2 3.2 0 110 5c-2.6 0-4.4-5-7-5z"/>',
    /* current regimen */
    bar:     '<rect x="4" y="9" width="13" height="8" rx="2"/><path d="M19 6.5c.9.9.9 2.1 0 3M16.5 4.5c1.6 1.6 1.6 3.4 0 5"/>',
    bottle:  '<path d="M10 3h4v3h-4z"/><path d="M8.5 6h7a2 2 0 012 2v11a2 2 0 01-2 2h-7a2 2 0 01-2-2V8a2 2 0 012-2z"/><path d="M8.5 12h7"/>',
    burn:    '<path d="M12 3s5 4.5 5 9a5 5 0 11-10 0c0-2 1-3.5 2-4.5 0 2 1 3 2 3 0-3 1-5.5 1-7.5z"/>',
    dropper: '<path d="M14 3l7 7-2 2-7-7z"/><path d="M12.5 6.5L5 14v5h5l7.5-7.5"/>',
    rx:      '<rect x="4" y="3.5" width="16" height="17" rx="2"/><path d="M8.5 16V9h3a2 2 0 010 4h-3M12 13l3.5 3"/>',
    question:'<circle cx="12" cy="12" r="9"/><path d="M9.5 9.5a2.6 2.6 0 115 1c0 1.7-2.5 1.8-2.5 3.5"/><circle cx="12" cy="17" r="1" fill="currentColor" stroke="none"/>',
    /* goal */
    sunrise: '<path d="M4 18h16M7 18a5 5 0 0110 0"/><path d="M12 5v3M5.5 8.5l2 2M18.5 8.5l-2 2"/>',
    spark:   '<path d="M12 3l2.2 5.8L20 11l-5.8 2.2L12 19l-2.2-5.8L4 11l5.8-2.2z"/>',
    clean:   '<path d="M5 8h14M5 12h9M5 16h11"/><circle cx="18" cy="16" r="2.2"/>',
    peak:    '<path d="M4 19l5-9 3 4 3-6 5 11z"/>'
  };

  function iconSvg(key) {
    var body = ICONS[key];
    if (!body) return "";
    return '<span class="q-option__icon" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" ' +
           'stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">' +
           body + "</svg></span>";
  }

  /* Rows render label + check only — and in config mode the engine puts NO id
     attribute on the button, so icons are matched by ORDER instead: the
     current step's options array lines up 1:1 with the rendered rows. */
  function optionIcons() {
    var rows = document.querySelectorAll(".q-option:not([data-iconed])");
    if (!rows.length) return;
    var host = document.querySelector("quiz-funnel");
    var cfg = window.QUIZ_CONFIG || {};
    var step = host && (cfg.questions || [])[host.idx];
    var opts = (step && step.options) || null;
    Array.prototype.forEach.call(rows, function (row, i) {
      row.setAttribute("data-iconed", "1");
      var o = opts && opts[i];
      if (!o || !o.icon) return;
      var body = row.querySelector(".q-option__body");
      if (body) body.insertAdjacentHTML("beforebegin", iconSvg(o.icon));
    });
  }

  /* ---- 1. The two-line headline -----------------------------------------
     The engine's own titleHTML() turns [[phrase]] into <span class="q-hl">,
     but it only runs on the intro title. Question and interstitial headings
     go through plain escaping, so [[ ]] would print literally there. This
     applies the same transform to those two, which is what lets every screen
     carry the brand's uppercase-line / sentence-case-brass-line device.     */
  function twoLine(node) {
    if (!node || node.dataset.brandDone) return;
    var raw = node.textContent || "";
    if (raw.indexOf("[[") === -1) { node.dataset.brandDone = "1"; return; }
    node.innerHTML = esc(raw).replace(/\[\[(.+?)\]\]/g, '<span class="q-hl">$1</span>');
    node.dataset.brandDone = "1";
  }

  /* ---- 2. Phone keypad ---------------------------------------------------
     The capture step reuses the engine's email input. Flipping type to tel
     is what makes a phone show the number pad instead of a text keyboard.  */
  function telInput() {
    var i = document.querySelector(".q-email__input[type=email]");
    if (!i) return;
    i.type = "tel";
    i.setAttribute("inputmode", "tel");
    i.setAttribute("autocomplete", "tel");
  }

  /* ---- 3. Rating strip ---------------------------------------------------
     intro.socialProof carries the business-wide rating. The system sets
     ★★★★★ in brass and the rest in cream, so the leading stars get split
     into their own span. The engine escapes the string, so this runs after. */
  function ratingStrip(node) {
    if (!node || node.dataset.brandDone) return;
    var m = (node.textContent || "").match(/^(★+)\s*(.*)$/);
    if (!m) { node.dataset.brandDone = "1"; return; }
    node.innerHTML = '<span class="q-social__stars">' + m[1] + "</span>" +
                     '<span class="q-social__txt">' + esc(m[2]) + "</span>";
    node.dataset.brandDone = "1";
  }

  /* ---- 4. The answer matrix (results page) -------------------------------
     Every man lands on the same three products, so copy is the only
     personalisation there is. This resolves results.matrix against what the
     visitor actually answered and rewrites three things:

       .r-h__top / .r-h__accent   ← winning concern × how long they've had it
       .r-sub                     ← the goal they picked
       .r-why__body               ← what they said they're using TODAY

     The engine has no hook for this. Its own `addOn` keys off SCORES, and
     the answers that matter most here (goal, regimen) deliberately carry no
     score, so scores cannot express it. Answers come from the saved result,
     which by this point IS written — unlike at capture time, where it isn't.

     Idempotent by comparison, not by a flag: the engine rewrites these nodes
     during hydration, so a one-shot guard would lose the race. Writing only
     when the text differs means the last word is always ours, and re-running
     on every mutation costs nothing. */
  function readResult() {
    try { return JSON.parse(sessionStorage.getItem("quizFunnelResult") || "null"); }
    catch (e) { return null; }
  }
  function firstAnswer(saved, key) {
    var a = saved && saved.answers && saved.answers[key];
    return (a && a.length) ? a[0] : null;
  }
  function setText(sel, txt) {
    var el = document.querySelector(sel);
    if (!el || !txt) return;
    if ((el.textContent || "").trim() !== txt) el.textContent = txt;
  }
  function answerCopy() {
    var m = ((window.QUIZ_CONFIG || {}).results || {}).matrix;
    if (!m || !document.querySelector(".r-body")) return;
    var saved = readResult();
    if (!saved) return;   /* no result yet — the engine shows its empty state */

    var byConcern = (m.headline || {})[saved.profileKey];
    var h = byConcern && byConcern[firstAnswer(saved, "duration")];
    if (h) {
      setText(".r-h__top", h.top);
      setText(".r-h__accent", h.accent);
    }

    var sub = (m.sub || {})[firstAnswer(saved, "goal")] || m.subDefault;
    var subEl = document.querySelector("[data-answer-sub]");
    if (subEl && sub) {
      if ((subEl.textContent || "").trim() !== sub) subEl.textContent = sub;
      subEl.hidden = false;
    }

    /* Falls through to profile.learn, which the engine already wrote, when
       the regimen answer is missing or unrecognised. */
    var why = (m.why || {})[firstAnswer(saved, "regimen")];
    if (why) setText(".r-why__body", why);
  }

  /* ---- 4b. The diagnosis ------------------------------------------------
     One row per answer they actually gave, showing what they said and the
     verdict on it. Nothing generic can reach this block: the row is built
     from the `verdict` string on the option itself, so an option without
     one simply produces no row, and a visitor who skipped a question sees
     nothing for it. If no row survives, the whole section stays hidden
     rather than rendering an empty frame. */
  function diagnose() {
    var host = document.querySelector("[data-diagnose]");
    if (!host) return;
    var list = host.querySelector(".r-diag__list");
    if (!list || list.children.length) return;   /* presence guard, not a flag */
    var saved = readResult();
    var cfg = window.QUIZ_CONFIG || {};
    if (!saved || !saved.answers) return;

    var rows = [];
    (cfg.questions || []).forEach(function (q) {
      var picked = saved.answers[q.id];
      if (!picked || !picked.length) return;
      (q.options || []).forEach(function (o) {
        if (picked.indexOf(o.id) === -1 || !o.verdict) return;
        rows.push({ said: o.factor || o.label, verdict: o.verdict });
      });
    });
    if (!rows.length) return;

    /* Four is the ceiling — past that it reads as a wall rather than a
       read-back, and the same cap the engine puts on `factors`. */
    rows.slice(0, 4).forEach(function (r) {
      var li = document.createElement("li");
      li.className = "r-diag__row";
      li.innerHTML = '<span class="r-diag__said">' + esc(r.said) + "</span>" +
                     '<span class="r-diag__verdict">' + esc(r.verdict) + "</span>";
      list.appendChild(li);
    });
    host.hidden = false;
  }

  /* ---- 5. The skip control ----------------------------------------------
     The engine's capture step already advances on an empty field, so skip
     always WORKED — there was just nothing to click. The design kit puts a
     tertiary control under the primary, so that is what this renders.

     It clears the field before triggering the primary, which is what keeps
     the skip honest: an empty field means the engine records no answer and
     fires no Lead event. The result still shows either way. */
  function skipControl() {
    var screen = document.querySelector(".q-screen--email");
    var inner = document.querySelector(".q-footer__inner");
    if (!screen || !inner || inner.querySelector(".q-skip")) return;

    var cfg = window.QUIZ_CONFIG || {};
    var step = (cfg.questions || []).filter(function (q) { return q.type === "email"; })[0] || {};
    var label = step.skipText;
    if (!label) return;

    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "q-skip";
    btn.textContent = label;
    btn.addEventListener("click", function () {
      var input = document.querySelector(".q-email__input");
      if (input) input.value = "";
      var cta = inner.querySelector(".q-cta");
      /* The primary is gated on ten digits (see captureBlock). Skip is the
         sanctioned way past an empty field, so it waives that gate for its
         own synthetic click — and only for that one click. */
      skipping = true;
      try { if (cta) cta.click(); } finally { skipping = false; }
    });
    inner.appendChild(btn);
  }

  /* ---- 6. Consent + lead relay ------------------------------------------
     Renders the TCPA disclosure under the phone field and posts the number
     to the relay when — and only when — one is actually submitted.

     Three things this deliberately does NOT do:
     · fire on skip. skipControl() clears the field first, so `value` is
       empty and we bail. A skipped step must leave no trace.
     · fire twice. `leadSent` guards re-renders and double taps.
     · call Postscript directly. That needs a private key, which cannot live
       in a public page — see the note in quiz.config.js.

     `consentHtml` is a fixed string from config, never user input, so
     innerHTML is safe here and is the only way to carry the required
     Terms/Privacy links. */
  var leadSent = false;
  var skipping = false;   /* set only while skipControl fires its own click */

  function digits(v) { return String(v || "").replace(/\D/g, ""); }

  function captureBlock() {
    var screen = document.querySelector(".q-screen--email");
    var input = document.querySelector(".q-email__input");
    if (!screen || !input || screen.dataset.leadWired) return;
    var cfg = window.QUIZ_CONFIG || {};
    var lead = cfg.lead || {};
    screen.dataset.leadWired = "1";

    /* Honeypot. The relay endpoint sits in public JS, so a bot can find it —
       the Zap should drop any payload where this arrived non-empty. */
    var pot = document.createElement("input");
    pot.type = "text";
    pot.name = "company";
    pot.tabIndex = -1;
    pot.autocomplete = "off";
    pot.setAttribute("aria-hidden", "true");
    pot.style.cssText = "position:absolute;left:-9999px;width:1px;height:1px;opacity:0";
    screen.appendChild(pot);

    if (lead.consentHtml) {
      var p = document.createElement("p");
      p.className = "q-consent";
      p.innerHTML = lead.consentHtml;
      input.insertAdjacentElement("afterend", p);
    }

    var footer = document.querySelector(".q-footer__inner");
    var cta = footer && footer.querySelector(".q-cta");
    if (!cta) return;

    /* ---- Gate the primary on a real number -------------------------------
       The engine advances on an empty field, so "Save my method" used to
       work with nothing typed — which makes the button a lie and sends the
       user past the step believing they saved something. Leaving is the
       Skip button's job, so the primary now refuses until there are ten
       digits, in the capture phase and the capture phase only.

       Capture runs on the mousedown that precedes the engine's own click
       handler, so stopping propagation here stops the advance too. */
    var err = document.createElement("p");
    err.className = "q-capture__err";
    err.setAttribute("role", "alert");
    err.hidden = true;
    err.textContent = "Enter a 10-digit mobile number, or tap Skip.";
    cta.insertAdjacentElement("beforebegin", err);

    function invalid() { return digits(input.value).length < 10; }
    function guard(ev) {
      if (skipping || !invalid()) { err.hidden = true; return; }
      ev.stopImmediatePropagation();
      ev.preventDefault();
      err.hidden = false;
      input.classList.add("is-invalid");
      input.focus();
    }
    cta.addEventListener("click", guard, true);
    cta.addEventListener("mousedown", guard, true);
    input.addEventListener("input", function () {
      if (!invalid()) { err.hidden = true; input.classList.remove("is-invalid"); }
    });

    cta.addEventListener("click", function () {
      if (leadSent) return;
      var phone = digits(input.value);
      if (phone.length < 10) return;        // guarded above; belt and braces
      if (digits(pot.value) || pot.value) return;  // bot
      if (!lead.endpoint) return;           // relay not configured yet
      /* consent_text below is built from config, not from the page. If the
         disclosure is not actually on screen at this moment, we would be
         recording a consent the customer never saw — so refuse to send.
         (The engine can rewrite a screen out from under us; see the note on
         the proof carousel.) */
      if (!screen.querySelector(".q-consent")) return;
      leadSent = true;

      /* Answers come off the live engine element, NOT sessionStorage: the
         result is only written during the analyse screen, which runs AFTER
         this step, so `quizFunnelResult` is still empty here. Without this
         the lead would reach Postscript with no segmentation data at all. */
      var el = document.querySelector("quiz-funnel");
      var answers = (el && el.answers) || null;
      var scores = (el && el.scores) || null;
      var leader = null;
      if (scores) {
        Object.keys(scores).forEach(function (k) {
          if (leader === null || scores[k] > scores[leader]) leader = k;
        });
      }

      /* Flat form-encoded fields, not a JSON blob. No-code tools (Pabbly,
         Zapier, Make) show each field by name and let you map it directly;
         a JSON body can arrive as one unparsed string. `answers` is the one
         nested thing, so it goes as a JSON string in a single field.

         URLSearchParams also makes this a CORS "simple" request — no
         preflight, which a cross-origin POST from a Shopify page would
         otherwise trigger and fail. */
      var body = new URLSearchParams();
      body.set("phone", input.value);
      body.set("source", lead.source || "quiz");
      body.set("profile", leader || "");
      body.set("answers", answers ? JSON.stringify(answers) : "");
      body.set("concerns", (answers && answers.concerns ? answers.concerns : []).join(","));
      /* Strip tags AND decode entities — this string is the consent record,
         so it has to read exactly as the customer saw it, not "&amp;". */
      var consentEl = document.createElement("div");
      consentEl.innerHTML = lead.consentHtml || "";
      body.set("consent_text", (consentEl.textContent || "").replace(/\s+/g, " ").trim());
      body.set("consent_at", new Date().toISOString());
      body.set("page_url", location.href);
      body.set("user_agent", navigator.userAgent);
      body.set("quiz_id", cfg.id || "");
      body.set("company", pot.value || "");   // honeypot — must be empty

      try {
        /* keepalive so the POST survives the redirect to the results page. */
        fetch(lead.endpoint, {
          method: "POST",
          body: body,
          keepalive: true,
          mode: "no-cors"
        }).catch(function () {});
      } catch (e) {}

      try {
        window.dispatchEvent(new CustomEvent("quiz:lead", { detail: { source: payload.source } }));
      } catch (e) {}
    }, true);
  }

  /* ---- 7. Proof carousel (intro) ----------------------------------------
     The engine's intro schema has no carousel, so it is rendered here and
     inserted between the headline and the CTA — where the design kit put
     its tips card.

     Swipe-native: a scroll-snap track, so it uses the platform's own
     momentum scrolling instead of a JS slider. Dots reflect position via
     IntersectionObserver. No autoplay — the system forbids it, and a
     proof element the visitor controls is more credible than one that
     moves on its own. */
  function proofCarousel() {
    var cfg = window.QUIZ_CONFIG || {};
    var proof = (cfg.intro || {}).proof;

    /* Mounts on the intro, and on any interstitial whose config carries its
       own `proof` block. The two screens deliberately show DIFFERENT
       customers: repeating the same four faces halfway through the funnel
       reads as "these are the only four we have". */
    var intro = document.querySelector(".q-intro");
    if (!intro) {
      /* Third host: the result page's own carousel, at the moment of the
         ask. Same component, different slides — results.proof. */
      var res = document.querySelector("[data-results-proof]");
      if (res) {
        var rp = ((cfg.results || {}).proof) || null;
        if (!rp || !rp.slides || !rp.slides.length) return;
        proof = rp;
        intro = res;
        res.hidden = false;
      } else {
        var inter = document.querySelector(".q-screen--interstitial");
        if (!inter) return;
        var host = document.querySelector("quiz-funnel");
        var step = host && (cfg.questions || [])[host.idx];
        if (!step || !step.proof) return;
        proof = step.proof;
        intro = inter;
      }
    }
    if (!proof || !proof.slides || !proof.slides.length) return;
    /* Guard on the carousel actually BEING there, not on a "we did this once"
       flag. The engine rewrites the screen's innerHTML after we mount, which
       wipes the carousel while leaving a dataset flag on the screen element
       intact — so a one-shot flag meant it never came back. On Shopify that
       race was lost every time and the interstitial rendered bare. Checking
       for the node makes the mount self-healing, and it settles immediately:
       re-adding .q-proof triggers one more apply() that finds it present. */
    if (intro.querySelector(".q-proof")) return;

    var wrap = document.createElement("div");
    wrap.className = "q-proof";

    var track = document.createElement("div");
    track.className = "q-proof__track";
    proof.slides.forEach(function (s) {
      var fig = document.createElement("figure");
      fig.className = "q-proof__slide";
      var stars = s.rating ? '<span class="q-proof__stars" aria-hidden="true">' +
        new Array(Math.max(0, Math.min(5, s.rating)) + 1).join("\u2605") + "</span>" : "";
      var quote = s.quote
        ? '<blockquote class="q-proof__quote">' + stars +
          '<span class="q-proof__qt">\u201C' + esc(s.quote) + '\u201D</span>' +
          '<span class="q-proof__verified">Verified buyer</span></blockquote>'
        : "";
      fig.innerHTML =
        '<img class="q-proof__img" src="' + esc(s.image) + '" loading="lazy" decoding="async" ' +
        'alt="' + esc(s.name) + ' — before and after. Unretouched customer photos.">' +
        '<figcaption class="q-proof__meta">' +
          '<span class="q-proof__side">Before</span>' +
          '<span class="q-proof__name">' + esc(s.name) + '</span>' +
          '<span class="q-proof__side">After</span>' +
        "</figcaption>" + quote;
      track.appendChild(fig);
    });

    /* Arrows. The track scroll-snaps and is swipeable, but on a touch device
       nothing on screen SAYS so — the dots read as a progress indicator, not
       a control. A chevron on each side is the affordance. They sit over the
       photo edges so they cost no vertical space. */
    /* scrollLeft directly, NOT scrollIntoView({behavior:"smooth"}). A smooth
       scroll on this track never lands: the MutationObserver that drives
       apply() fires continuously and cancels the animation mid-flight, so
       scrollLeft returns to 0 every time. (This is also why the dots did
       nothing before — they used the same smooth call.) An instant snap is
       the honest trade: a control that always works beats one that eases. */
    /* NOT named step(): `var step` above already holds the config question
       for this screen, and a var declaration wins over a function
       declaration of the same name — which made this throw on exactly the
       interstitial, the one screen that assigns it. */
    function slideStep() {
      var a = track.children[0], b = track.children[1];
      if (a && b) return b.offsetLeft - a.offsetLeft;   /* includes the gap */
      return (a && a.offsetWidth) || 1;
    }
    function goTo(i) {
      i = Math.max(0, Math.min(track.children.length - 1, i));
      track.scrollLeft = i * slideStep();
      syncArrows();
    }
    function go(delta) { goTo(current() + delta); }
    function current() { return Math.round(track.scrollLeft / slideStep()); }
    function arrow(dir) {
      var b = document.createElement("button");
      b.type = "button";
      b.className = "q-proof__arrow q-proof__arrow--" + (dir < 0 ? "prev" : "next");
      b.setAttribute("aria-label", dir < 0 ? "Previous customer" : "Next customer");
      b.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" ' +
        'stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
        (dir < 0 ? '<path d="M15 5l-7 7 7 7"/>' : '<path d="M9 5l7 7-7 7"/>') + "</svg>";
      b.addEventListener("click", function () { go(dir); });
      return b;
    }
    var prev = arrow(-1), next = arrow(1);
    var stage = document.createElement("div");
    stage.className = "q-proof__stage";
    wrap.appendChild(stage);
    stage.appendChild(track);
    stage.appendChild(prev);
    stage.appendChild(next);

    var dots = document.createElement("div");
    dots.className = "q-proof__dots";
    proof.slides.forEach(function (_, i) {
      var b = document.createElement("button");
      b.type = "button";
      b.className = "q-proof__dot" + (i === 0 ? " is-on" : "");
      b.setAttribute("aria-label", "Show customer " + (i + 1));
      b.addEventListener("click", function () { goTo(i); });
      dots.appendChild(b);
    });
    wrap.appendChild(dots);

    /* Grey out an arrow at the end of the track rather than hiding it —
       a control that vanishes is more confusing than one that dims. */
    function syncArrows() {
      var i = current();
      prev.disabled = i <= 0;
      next.disabled = i >= track.children.length - 1;
    }
    track.addEventListener("scroll", syncArrows, { passive: true });
    syncArrows();

    if (proof.caption) {
      var cap = document.createElement("p");
      cap.className = "q-proof__caption";
      cap.textContent = proof.caption;
      wrap.appendChild(cap);
    }

    /* Insert before the CTA block so the order matches the kit:
       headline → proof → button → rating. */
    var cta = intro.querySelector(".q-cta");
    if (cta && cta.parentNode === intro) intro.insertBefore(wrap, cta);
    else intro.appendChild(wrap);   // interstitial: CTA is in the fixed footer

    if ("IntersectionObserver" in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          var idx = Array.prototype.indexOf.call(track.children, en.target);
          Array.prototype.forEach.call(dots.children, function (d, i) {
            d.classList.toggle("is-on", i === idx);
          });
          syncArrows();
        });
      }, { root: track, threshold: 0.6 });
      Array.prototype.forEach.call(track.children, function (c) { io.observe(c); });
    }
    syncArrows();   /* again, now that the track is laid out and has a width */
  }

  /* ---- 8. Results hero video --------------------------------------------
     Muted + loop + playsinline is the only autoplay the system allows, and
     it is what lets it start on iOS at all. A poster covers the gap before
     the first frame decodes. */

  /* ---- 7b. FREE tag on included items -----------------------------------
     The towel is a real product (MIRO™ Face Towel, $9.99) and the list should
     name it, with the fact that it costs nothing carried by a tag rather than
     baked into the name — "Free towel" named no product and read like filler.

     The tag cannot ride on the config item: quiz-engine.js flattens every
     `includes` entry to a plain string before render, so an object would lose
     it. results.includesFree lists the rows that get tagged, matched on text. */
  function includesFree() {
    var free = ((window.QUIZ_CONFIG || {}).results || {}).includesFree;
    if (!free || !free.length) return;
    var rows = document.querySelectorAll(".r-includes li:not([data-freed])");
    Array.prototype.forEach.call(rows, function (li) {
      li.setAttribute("data-freed", "1");
      var txt = (li.textContent || "").trim();
      if (free.indexOf(txt) === -1) return;
      var tag = document.createElement("span");
      tag.className = "r-free";
      tag.textContent = "Free";
      li.appendChild(tag);
    });
  }

  function heroVideo() {
    var host = document.querySelector("[data-hero-video]");
    if (!host || host.dataset.heroDone) return;
    var v = ((window.QUIZ_CONFIG || {}).results || {}).video;
    if (!v || !v.src) return;
    host.dataset.heroDone = "1";
    host.hidden = false;

    /* Full 9:16, uncropped: it is a phone-shot reel and the speaker's hands
       and face run to the edges of the frame. It starts muted because that
       is the only autoplay any browser allows, but this one TALKS — there
       are no burned-in captions — so it ships with native controls and a
       sound button over the frame. Tapping either unmutes and restarts from
       the top, which is the only way the first sentence isn't lost. */
    host.innerHTML =
      '<div class="r-hero__frame">' +
        '<video class="r-hero__v" autoplay muted loop playsinline controls preload="metadata"' +
        (v.poster ? ' poster="' + esc(v.poster) + '"' : "") +
        ' aria-label="' + esc(v.alt || "") + '">' +
        '<source src="' + esc(v.src) + '" type="video/mp4"></video>' +
        '<button type="button" class="r-hero__sound">' +
          '<span class="r-hero__soundicon" aria-hidden="true">▶</span>' +
          "<span>Tap for sound</span></button>" +
      "</div>";

    var vid = host.querySelector("video");
    var btn = host.querySelector(".r-hero__sound");
    function unmute() {
      vid.muted = false;
      vid.currentTime = 0;
      var p = vid.play();
      if (p && p.catch) p.catch(function () {});
      btn.hidden = true;
    }
    btn.addEventListener("click", unmute);
    /* If the viewer reaches for the native controls first, drop our prompt
       rather than leaving two competing sound affordances on the frame. */
    vid.addEventListener("volumechange", function () {
      if (!vid.muted) btn.hidden = true;
    });
  }

  function apply() {
    heroVideo();
    includesFree();
    proofCarousel();
    optionIcons();
    document.querySelectorAll(".q-question, .q-inter__title").forEach(twoLine);
    document.querySelectorAll(".q-social").forEach(ratingStrip);
    telInput();
    answerCopy();
    diagnose();
    skipControl();
    captureBlock();
  }

  new MutationObserver(apply).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener("DOMContentLoaded", apply);
  apply();
})();
